module.exports = __webpack_public_path__ + "static/media/cach-dieu-tri-nhiem-trung-mau-01-1-e1565923445690.cf1f9d3e.png";